import React from 'react';
import style from './CurrentFairValue.module.css';
import UpsideBadge from '../UpsideBadge/UpsideBadge';

const CurrentFairValue = ({ discounted_cash_flows, price }) => {
  if (discounted_cash_flows === null || discounted_cash_flows.dcf === null) {
    return null;
  }

  const dcf = parseFloat(discounted_cash_flows.dcf) || 0;
  const priceToday = price || 0;

  const change = dcf !== 0 ? ((dcf / priceToday) * 100 - 100).toFixed(1) : 0;

  return (
    <div className={style.container}>
      <span className={style.price}>${dcf.toFixed(2)}</span>
      <h3 className={style.headline}>Current Fair Value</h3>
      <UpsideBadge change={change} />
      {change > 0 ? (
        <p className={style.text}>Undervalued by {Math.abs(change)}% based on the discounted cash flow analysis.</p>
      ) : (
        <p className={style.text}>Overvalued by {Math.abs(change)}% based on the discounted cash flow analysis.</p>
      )}
    </div>
  );
};

export default CurrentFairValue;